// routes.js

import Error404 from "../views/Error404";
import AllDeals from "../views/AllDeals/AllDeals";
import MyDeals from "../views/MyDeals/MyDeals";
import Settings from "../views/Settings/Settings";
import Impressum from "../views/impressum/Impressum";
import Deallist from "@/views/Deallist/Deallist";
import DeallistArchived from "@/views/Deallist/DeallistArchived";
import DealDetails from "@/views/DealDetails";

const routes = [
    {
        path: '/',
        name: 'deals',
        component: AllDeals,
        /*meta: {
            breadCrumb: 'All Deals',
            parents: [
                {route: '/', name: 'deals'}
            ]
        }*/
    },
    {
        path: '/deals/:id',
        name: 'dealDetails',
        component: DealDetails,
    },
    {
        path: '/mydeals/:id',
        name: 'mydeals',
        component: MyDeals,
        /*meta: {
            breadCrumb: 'All Deals',
            parents: [
                {route: '/', name: 'deals'}
            ]
        }*/
    },
    {
        path: '/mydeals',
        name: 'mydealsall',
        component: MyDeals,
        /*meta: {
            breadCrumb: 'All Deals',
            parents: [
                {route: '/', name: 'deals'}
            ]
        }*/
    },
    {
        path: '/deallist',
        name: 'deallist',
        component: Deallist,
    },
    {
        path: '/deallist/archived',
        name: 'deallistArchived',
        component: DeallistArchived,
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings,
        /*meta: {
            breadCrumb: 'All Deals',
            parents: [
                {route: '/', name: 'deals'}
            ]
        }*/
    }, {
        path: '/impressum',
        name: 'impressum',
        component: Impressum,
        /*meta: {
            breadCrumb: 'All Deals',
            parents: [
                {route: '/', name: 'deals'}
            ]
        }*/
    },
    {
        path: '*',
        component: Error404
    }
];

export default routes;